import { AfterContentInit, Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { Subscription } from 'rxjs';

//formats a bid input as USD currency while typing and keeps the caret before '.00' if decimals are not allowed
@Directive({
  selector: 'input[appBidAmountInput]',
  standalone: false
})
export class BidAmountInputDirective implements AfterContentInit, OnDestroy {
  @Input() allowDecimals = false;

  private subscription?: Subscription;

  constructor(private el: ElementRef<HTMLInputElement>, private ngControl: NgControl, private currencyPipe: CurrencyPipe) {}

  ngAfterContentInit() {
    //subscribe here and not in ngOnInit: formControlName connects its control in its own ngOnChanges, which may run after our ngOnInit
    this.subscription = this.ngControl.valueChanges?.subscribe(value => this.format(value));
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  @HostListener('selectionchange')
  onSelectionChange() {
    //make sure cursor stays before '.00' in case user cannot enter decimals
    const value = this.ngControl.value;
    if (!this.allowDecimals && value) {
      const input = this.el.nativeElement;
      const dotIndex = value.indexOf('.');
      if (input.selectionStart! > dotIndex) input.selectionEnd = dotIndex;
    }
  }

  private format(bid: string | null) {
    if (!bid) return;
    const control = this.ngControl.control!;
    if (this.allowDecimals) {
      //we need to allow decimals, but only one and avoid rounding if more than 2 decimals are entered
      const value = bid.replace(/[^0-9.]+/g, '').replace(/^0+/, '');
      if (value[value.length-1] == '.') {
        //last character entered is a decimal => check if another decimal exists
        if (value.indexOf('.') != value.length-1) {
          //don't allow another decimal
          control.setValue(this.currencyPipe.transform(value.substring(0, value.length-1), 'USD', 'symbol', '1.0-2'), { emitEvent: false });
        }
      }
      else if (value.length >= 3 && value.indexOf('.') > -1 && value.indexOf('.') == value.length-4) {
        //if already 2 decimals ignore next ones
        control.setValue(this.currencyPipe.transform(value.substring(0, value.length-1), 'USD', 'symbol', '1.0-2'), { emitEvent: false });
      }
      else {
        control.setValue(this.currencyPipe.transform(value, 'USD', 'symbol', '1.0-2'), { emitEvent: false });
      }
    }
    else {
      //don't allow decimals
      const value = bid.split('.')[0];
      control.setValue(this.currencyPipe.transform(value.replace(/\D/g, '').replace(/^0+/, ''), 'USD', 'symbol', '1.2-2'), { emitEvent: false });
      const length = control.value?.length;
      this.el.nativeElement.selectionEnd = length ? length-3 : 0;
    }
  }
}
